module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/22fbd0a5bc8f309a13c68f5dd7bb63f0.png";